<style scoped lang="scss">
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.cons{
  display: none;
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
//.table{
//  tr{
//    td:first-child{
//      background: #F6FAFD;
//    }
//  }
//}
.c-title small{
  margin-top: 10px;
}
.compose-type1{
  margin-top: 100px;
  padding-bottom: 50px;
  background: url("../../assets/img/Virus/Adenovirus/ys_bg.png") no-repeat;
  background-size: 100% 100%;
}
.required{
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}
.zaiti{
  overflow: auto;
  font-size: 16px;
}
.zaiti .desc{
  margin-bottom: 10px;
}
.zaiti ul li{
  padding-bottom: 20px;
}
.zaiti ul li:last-child{
  padding-bottom: 0;
}
.service {
  background: #F7FBFE;
  padding-bottom: 60px;

  .c-title {
    padding: 60px 0;
  }

  .content {
    display: flex;
    img{
      width: 100%;
    }
    &-text {
      font-size: 16px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (min-width: 300px) and (max-width:400px){
  .desc1{
    margin-top: 30px!important;
  }
}
@media screen and (max-width: 414px) and (min-width: 413px){
  .desc1{
    margin-top: 30px!important;
  }
}
@media screen and (max-width: 640px) and (min-width: 600px){
  .desc1{
    margin-top: 30px!important;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">

    <div class="banner con">
      <img src="@/assets/img/Virus/Adeno/bannerNew.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons">
      <img src="@/assets/img/二级标题Banner/AAV_腺相关病毒包装banner.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container">
        <p class="desc" style="margin-bottom: 10px;color:#014492;font-weight:bold;">腺相关病毒包装</p>
        <p class="desc">腺相关病毒(Adena-associated Virus,AAV)属于细小病毒科(Parvoviridae)，单链DNA病毒(~4.8 kb)，经过改造的rAAV病毒工具已被广泛的应用在动物水平的基因表达、基因操作和基因治疗。AAV病毒颗粒无包膜，结构为直径约20 nm的正二十面体。1965年，AAV从腺病毒制备物中发现，并由此得名。AAV是迄今发现的一类结构简单的单链DNA缺陷型病毒，通常需要在辅助病毒(如:腺病毒 单纯疱疹病毒等)的辅助下才能发生产毒性感染，生成子代AAV。</p>
        <p class="desc">优势：</p>
        <p class="desc">1.安全性高：基因组整合概率和免疫原性低、实验操作安全性更高。</p>
        <p class="desc">2.免疫原性低：注射动物实验时造成的免疫反应小。</p>
        <p class="desc">3.广泛的感染谱和特异性：几乎所有哺乳动物的器官都能被自然界存在的AAV感染，经过改造，擎科生物可提供靶向不同器官的rAAV血清型，配合特异性启动子以便进行特异性表达。</p>
        <div class="gene_img con" style="text-align: center"><img width="100%" src="@/assets/img/Virus/Adenovirus/Adeno_associated_virus.png"></div>
        <p style="margin-bottom: 10px;text-align:center;font-size:12px">腺相关病毒包装和感染原理图</p>
      </div>
      <div class="container con">
      <div class="c-title">服务内容<small>Service Details</small></div>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            :span-method="handleServiceDetails"
            :data="ServiceDetailsTableData">
            <el-table-column
              prop="product"
              label="产品大类">
            </el-table-column>
            <el-table-column
              prop="name"
              width="180px"
              label="产品名称">
            </el-table-column>
            <el-table-column
              prop="number"
              label="总量">
            </el-table-column>
            <el-table-column
              prop="time"
              label="周期(工作日)">
            </el-table-column>
            <el-table-column
              prop="directory"
              label="目录价（元）">
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注">
              <template slot-scope="scope">
                <div v-html="scope.row.remark"></div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin: 30px 0;">其他定制型AAV价格请联系当地销售，具体价格以评估为准。</div>
        <div style="margin-bottom: 30px;display: flex;align-items: center;"><span style="font-size:40px;margin-right:10px">•</span>  AAV定制包装服务擎科生物可提供的血清型及靶向组织血清型推荐，供您参考</div>
        <div style="margin-bottom: 30px;">
          目前，从自然界已经分离出了12种血清型的AAV，从人类细胞中分离的有(AAV2、3、5、6)从非人类动物细胞中分离的有 (AAV1、4和7~12)。自然界中分离得到的AAV突变型已达100多种。不同血清型AAV的衣壳蛋白识别细胞表面的受体不同，因而对不同组织细胞的侵染效率差异很大，表现出一定的器官靶向特异性。通过对AAV病毒载体的衣壳蛋白 Cap基因进行定向突变改造，可以筛选到具有高转导效果和不同感染性的AAV载体，大大增加了AAV的应用潜力。
        </div>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            height="680px"
            :data="serotypeTableData">
            <el-table-column
              prop="number">
            </el-table-column>
            <el-table-column
              prop="type"
              label="血清型">
            </el-table-column>
            <el-table-column
              prop="desc"
              label="靶向组织（常用标红）">
              <template slot-scope="scope">
                <div v-html="scope.row.desc"></div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin: 30px 0;display: flex;align-items: center;"><span style="font-size:40px;margin-right:10px">•</span>  AAV定制包装服务擎科生物可提供的特异性启动子</div>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            height="680px"
            :span-method="handleTypeDetails"
            :data="customizedPackagingTableData">
            <el-table-column
              prop="type"
              label="类型">
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称">
            </el-table-column>
            <el-table-column
              prop="desc"
              label="应用">
              <template slot-scope="scope">
                <div v-html="scope.row.desc"></div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="container con" style="margin-bottom: 50px;">
        <div class="c-title">服务流程<small>Service Process</small></div>
        <div class="gene_img con" style="text-align: center"><img src="@/assets/img/Virus/Adenovirus/lc_new.png" width="100%"></div>
        <!-- <div class="gene_img cons" style="text-align: center"><img src="@/assets/img/Virus/Adenovirus/lc_2.png"></div> -->
      </div>
      <div class="service mt100 con">
        <div class="container">
          <div class="c-title">服务优势<small>Service Advantages</small></div>
            <div class="">
                <div class="content-text">
                  <p class="mb20" style="font-weight:bold">高滴度</p>
                  <p class="mb20">高效腺相关病毒包装系统，</p>
                  <p class="mb20">滴度根据客户需求可高达1E+14 VGS/mL</p>
                  <p class="mb20" style="font-weight:bold">高纯度</p>
                  <p class="mb20">采用超速离心过滤，高纯度、低残留，可达in vivo级</p>
                  <p class="mb20" style="font-weight:bold">广泛的感染谱和特异性</p>
                  <p class="mb20">提供靶向不同器官的rAAV血清型，配合特异性启动子以便进行特异性表达。</p>
                </div>
            </div>
        </div>
      </div>
      <div class="container con">
        <div class="c-title">案例展示<small>Case</small></div>
        <p class="mb20" style="font-size:22px">AAV体外应用：擎科生物不同血清型AAV病毒对不同细胞的均有较好的感染效果。</p>
        <div class="tables" >
          <div class="gene_img con" style="text-align: center"><img src="@/assets/img/Virus/Adenovirus/case.png"></div>
        </div>
      </div>
      <div class="container cons">
        <div class="c-title">产品说明<small>Product description</small></div>
        <p class="desc">根据实验得出的体内实验血清型推荐表</p>
        <p class="desc">动物体内实验血清型推荐表(小鼠)</p>
        <table class="table">
          <tr>
            <td style="width:300px;">器官组织</td>
            <td>小鼠实验推荐血清型</td>
          </tr>
          <tr>
            <td style="width:300px;">周边神经系统</td>
            <td>AAV-PHP.S.9、h10、5.8</td>
          </tr>
          <tr>
            <td style="width:300px;">中枢神经系统</td>
            <td>AAV-PHP.eB、2、9. th10、5、8</td>
          </tr>
          <tr>
            <td style="width:300px;">全脑</td>
            <td>AAV-PHP.eB、1.2.5.8</td>
          </tr>
          <tr>
            <td style="width:300px;">跨血脑屏障</td>
            <td>AAV-PHP.eB、9. rh10</td>
          </tr>
          <tr>
            <td style="width:300px;">脑组织、侧脑室</td>
            <td>AAV9、th10</td>
          </tr>
          <tr>
            <td style="width:300px;">逆向非跨突触标记</td>
            <td>AAV2-retro(AAV-retro)</td>
          </tr>
          <tr>
            <td style="width:300px;">肝</td>
            <td>AAV8、9. rh10</td>
          </tr>
          <tr>
            <td style="width:300px;">肾</td>
            <td>AAV2</td>
          </tr>
          <tr>
            <td style="width:300px;">心脏</td>
            <td>AAV9、h10、1</td>
          </tr>
          <tr>
            <td style="width:300px;">骨骼肌(心肌)</td>
            <td>AAV7、8.9、M10、1</td>
          </tr>
          <tr>
            <td style="width:300px;">眼睛</td>
            <td>AAV-Anc80、5、6.9、1.2</td>
          </tr>
          <tr>
            <td style="width:300px;">耳</td>
            <td>AAV-Anc80、I.E、2、6</td>
          </tr><tr>
          <td style="width:300px;">肺</td>
          <td>AAV5、9、6</td>
        </tr>
          <tr>
            <td style="width:300px;">胰腺</td>
            <td>AAV8、9、5</td>
          </tr>
          <tr>
            <td style="width:300px;">脂肪</td>
            <td>AAV9</td>
          </tr>
          <tr>
            <td style="width:300px;">前列腺</td>
            <td>AAV7</td>
          </tr>
          <tr>
            <td style="width:300px;">全身</td>
            <td>AAV9、rh10</td>
          </tr>
        </table>
        <p class="desc desc1" style="margin-top: 100px;">我们可提供的特异性启动子</p>
        <table class="table">
          <tr>
            <td style="width:300px;">名称</td>
            <td>特异性</td>
            <td>长度(bp)</td>
          </tr>
          <tr>
            <td style="width:300px;">EFS</td>
            <td>广谱</td>
            <td>256</td>
          </tr>
          <tr>
            <td style="width:300px;">CAG</td>
            <td>广谱</td>
            <td>812</td>
          </tr>
          <tr>
            <td style="width:300px;">EFla</td>
            <td>广谱</td>
            <td>1178</td>
          </tr>
          <tr>
            <td style="width:300px;">CMV</td>
            <td>广谱</td>
            <td>573</td>
          </tr>
          <tr>
            <td style="width:300px;">TBG</td>
            <td>肝</td>
            <td>714</td>
          </tr>
          <tr>
            <td style="width:300px;">Elastase-1</td>
            <td>胰腺，acinar细胞</td>
            <td>401</td>
          </tr>
          <tr>
            <td style="width:300px;">大鼠Insulin2</td>
            <td>胰腺，beta细胞</td>
            <td>500</td>
          </tr>
          <tr>
            <td style="width:300px;">小Insulin2</td>
            <td>胰腺，beta细胞</td>
            <td>494</td>
          </tr>
          <tr>
            <td style="width:300px;">hDesmin</td>
            <td>骨骼肌，心肌</td>
            <td>603</td>
          </tr>
          <tr>
            <td style="width:300px;">hSyn</td>
            <td>神经元neuron</td>
            <td>480</td>
          </tr>
          <tr>
            <td style="width:300px;">hGFAP</td>
            <td>神经系统，星形胶质细胞astrocytes</td>
            <td>2208</td>
          </tr>
          <tr>
            <td style="width:300px;">hMeCP2</td>
            <td>神经元neuron</td>
            <td>245</td>
          </tr>
          <tr>
            <td style="width:300px;">CaMKlla</td>
            <td>新皮质和海马体中的兴奋性神经元(excitatory neurons)</td>
            <td>1307</td>
          </tr>
          <tr>
            <td style="width:300px;">小鼠TRP-2</td>
            <td>色素细胞</td>
            <td>1705</td>
          </tr>
          <tr>
            <td style="width:300px;">mGAD1</td>
            <td>GABA能神经元</td>
            <td>625</td>
          </tr>
          <tr>
            <td style="width:300px;">rMCPT5</td>
            <td>肥大细胞</td>
            <td>830</td>
          </tr>
          <tr>
            <td style="width:300px;">hGFAP848</td>
            <td>神经系统，星形胶质细胞astrocytes</td>
            <td>848</td>
          </tr>
          <tr>
            <td style="width:300px;">CTNT</td>
            <td>心肌细胞</td>
            <td>717</td>
          </tr>
          <tr>
            <td style="width:300px;">CBh</td>
            <td>广谱</td>
            <td>799</td>
          </tr>
          <tr>
            <td style="width:300px;">EF1</td>
            <td>广谱</td>
            <td>546</td>
          </tr>
          <tr>
            <td style="width:300px;">CaMKlla370</td>
            <td>新皮质和海马体中的兴奋性神经元(excitatory neurons)</td>
            <td>370</td>
          </tr>
          <tr>
            <td style="width:300px;">CAGW</td>
            <td>广谱</td>
            <td>984</td>
          </tr>
          <tr>
            <td style="width:300px;">TH</td>
            <td>神经系统，多巴胺能神经细胞</td>
            <td>524</td>
          </tr>
          <tr>
            <td style="width:300px;">miniCMV</td>
            <td>广谱</td>
            <td>180</td>
          </tr>
        </table>
        <p class="desc desc1" style="margin-top: 100px;">单链ITR载体</p>
        <p class="desc">血清型：AAV1、3b、5、7、8、9、PHP.eB、PHP.B、PHP.S、rh10、DJ、2-retro、DJ/8</p>
        <div class="tables" >
          <el-table
            border
            :span-method="objectSpanMethod"
            class="method-table"
            :data="tableData">
            <el-table-column
              prop="method1"
              label="服务类别">
            </el-table-column>
            <el-table-column
              prop="method2"
              label="滴度总量">
            </el-table-column>
            <el-table-column
              prop="method3"
              label="费用（¥）">
            </el-table-column>
            <el-table-column
              prop="method4"
              label="适用小鼠数 (靶向肝脏)">
            </el-table-column>
            <el-table-column
              prop="method5"
              label="周期(工作日)">
            </el-table-column>
          </el-table>
        </div>
        <p class="desc desc1" style="margin-top: 100px;">双链ITR载体</p>
        <p class="desc">血清型：AAV2、4、6、6.2、7m8</p>
        <div class="tables" >
          <el-table
            border
            :span-method="objectSpanMethod"
            class="method-table"
            :data="tableData1">
            <el-table-column
              prop="method1"
              label="服务类别">
            </el-table-column>
            <el-table-column
              prop="method2"
              label="滴度总量">
            </el-table-column>
            <el-table-column
              prop="method3"
              label="费用（¥）">
            </el-table-column>
            <el-table-column
              prop="method4"
              label="适用小鼠数 (靶向肝脏)">
            </el-table-column>
            <el-table-column
              prop="method5"
              label="周期(工作日)">
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 50px;">其他定制型AAV价格请联系当地销售，具体价格以评估为准。</div>
      </div>
      <div class="compose-type1 cons">
        <div class="container">
          <div class="c-title">服务优势<small>Service advantage</small></div>
          <div class="neirong" style="display: flex">
            <div class="left ">
              <img src="@/assets/img/Virus/Adeno/ys.png" class="img-fluid">
            </div>
            <div class="right">
              <div class="required">
                <p class="mb20">1.<span style="font-weight:bold;">安全性高：</span>基因组整合概率和免疫原性低、实验操作安全性更高。</p>
                <p class="mb20">2.<span style="font-weight:bold;">免疫原性低：</span>注射动物实验时造成的免疫反应小。</p>
                <p class="mb20">3.<span style="font-weight:bold;">广泛的感染谱和特异性：</span>几乎所有哺乳动物的器官都能被自然界存在的AAV感染，经过改造，擎科生物可提供靶向不同器官的rAAV血清型，配合特异性启动子以便进行特异性表达。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container cons">
        <div class="c-title">资源中心<small>Resource center</small></div>
        <div class="container mt30 mb30">
          <ul class="download">
            <li v-for="item in resourcesLists" :key="item.id">
              {{item.name}}
              <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <ul class="effect-lists con">
          <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
            <img :src="`/static/images/Virus_${item.img}${currentType===index ? '' : ''}.png`">
            <p style="margin-top: 10px;">{{item.name}}</p>
          </li>
        </ul>
        <div class="cons">
          <ul class="effect-lists" style="margin-top: 20px;display: flex!important;justify-content: center!important;">
            <li v-for="(item, index) in types" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/images/Virus_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>

      </div>
      <div class="container">
        <qk-consult type="Adeno_associated_virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
import { ServiceDetailsTableData, serotypeTableData, customizedPackagingTableData } from "./contans.js"
import _ from 'lodash'
export default {
  components:{
    bread
  },
  data () {
    return {
      tableData:[
        {
          method1:'常规产量型',
          method2:'高纯1E+12GC',
          method3:'8800',
          method4:'5',
          method5:'10-15',
        },
        {
          method1:'',
          method2:'高纯2E+12GC',
          method3:'10800',
          method4:'10',
          method5:'10-15',
        },
        {
          method1:'',
          method2:'高纯5E+12GC',
          method3:'13500',
          method4:'25',
          method5:'10-15',
        },
        {
          method1:'',
          method2:'高纯1E+13GC',
          method3:'21000',
          method4:'100',
          method5:'10-15',
        },
        {
          method1:'',
          method2:'高纯2E+13GC',
          method3:'35800',
          method4:'200',
          method5:'10-15',
        },
        {
          method1:'',
          method2:'高纯5E+13GC',
          method3:'63000',
          method4:'500',
          method5:'10-15',
        },
        {
          method1:'',
          method2:'高纯1E+14GC',
          method3:'100000',
          method4:'1000',
          method5:'10-15',
        },
      ],
      tableData1:[
        {
          method1:'低产量型',
          method2:'高纯1E+12GC',
          method3:'10800',
          method4:'5',
          method5:'10-15',
        },
        {
          method1:'',
          method2:'高纯2E+12GC',
          method3:'13450',
          method4:'10',
          method5:'10-15',
        },
        {
          method1:'',
          method2:'高纯5E+12GC',
          method3:'21000',
          method4:'25',
          method5:'10-15',
        },
        {
          method1:'',
          method2:'高纯1E+13GC',
          method3:'35800',
          method4:'100',
          method5:'10-15',
        },
        {
          method1:'',
          method2:'高纯2E+13GC',
          method3:'63000',
          method4:'200',
          method5:'10-15',
        },
        {
          method1:'',
          method2:'高纯5E+13GC',
          method3:'100000',
          method4:'500',
          method5:'10-15',
        },
        {
          method1:'',
          method2:'高纯1E+14GC',
          method3:'180000',
          method4:'1000',
          method5:'10-15',
        },
      ],
      ServiceDetailsTableData: ServiceDetailsTableData,
      serotypeTableData: serotypeTableData,
      customizedPackagingTableData: customizedPackagingTableData,
      spanArr:[],
      currentType: -1,
      currentService: -1,
      types: [
        {name: '腺病毒包装', img: '2', ref: '/Virus/Adenovirus_packaging'},
        {name: '慢病毒包装', img: '1', ref: '/Virus/Lentivirus_packaging'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  mounted() {
    this.getSpanArr(this.tableData);
    this.getSpanArr(this.tableData1);
  },
  methods: {
    getSpanArr(data) {
      console.log(data)
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0
        } else {
          // 判断当前元素与上一个元素是否相同,因合并第一个所以[0]
          if (data[i][0] === data[i - 1][0]) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    handleServiceDetails({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 14 === 0) {
          return {
            rowspan: 14,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 1) {
        if (rowIndex === 0) {
          return {
            rowspan: 8,
            colspan: 1
          };
        }else if (rowIndex === 8) {
          return {
            rowspan: 6,
            colspan: 1
          };
        }else if (rowIndex === 14) {
          return {
            rowspan: 9,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (columnIndex === 5) {
        if(rowIndex === 0 || rowIndex === 14) {
          return {
            rowspan: 5,
            colspan: 1
          };
        }else if(rowIndex === 5) {
          return {
            rowspan: 3,
            colspan: 1
          };
        }else if(rowIndex === 8) {
          return {
            rowspan: 6,
            colspan: 1
          };
        }else if(rowIndex === 19) {
          return {
            rowspan: 4,
            colspan: 1
          };
        }else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    handleTypeDetails({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if(rowIndex === 0) {
          return {
            rowspan: 26,
            colspan: 1
          };
        }else if (rowIndex === 26 || rowIndex === 29|| rowIndex === 34) {
          return {
            rowspan: 3,
            colspan: 1
          };
        }else if (rowIndex === 37 || rowIndex === 39 || rowIndex === 42) {
          return {
            rowspan: 2,
            colspan: 1
          };
        }else if(rowIndex === 44 || rowIndex === 41|| rowIndex === 33|| rowIndex === 32) {

        } else{
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/Virus/Adeno_associated_virus.vue